import React from 'react';
import styles from './LegalPage.module.css';
import {
  PUBLIC_BETA_NOTICE_PARAGRAPHS,
  PUBLIC_BETA_NOTICE_SUPPORT_EMAIL,
} from './publicBetaNoticeContent';

const PublicBetaNotice = () => (
  <div className={styles.content}>
    <div className={styles.noticeBody}>
      {PUBLIC_BETA_NOTICE_PARAGRAPHS.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
      <p>
        Questions:{' '}
        <a href={`mailto:${PUBLIC_BETA_NOTICE_SUPPORT_EMAIL}`}>
          {PUBLIC_BETA_NOTICE_SUPPORT_EMAIL}
        </a>
      </p>
    </div>
  </div>
);

export default PublicBetaNotice;
